import gql from "graphql-tag";
import * as Urql from "urql";
export var PreferredLanguage;
(function (PreferredLanguage) {
    PreferredLanguage["AmericanSignLanguageAsl"] = "AMERICAN_SIGN_LANGUAGE__ASL_";
    PreferredLanguage["Arabic"] = "ARABIC";
    PreferredLanguage["Armenian"] = "ARMENIAN";
    PreferredLanguage["Bosnian"] = "BOSNIAN";
    PreferredLanguage["Cantonese"] = "CANTONESE";
    PreferredLanguage["Croatian"] = "CROATIAN";
    PreferredLanguage["English"] = "ENGLISH";
    PreferredLanguage["Farsi"] = "FARSI";
    PreferredLanguage["Filipino"] = "FILIPINO";
    PreferredLanguage["French"] = "FRENCH";
    PreferredLanguage["German"] = "GERMAN";
    PreferredLanguage["Greek"] = "GREEK";
    PreferredLanguage["Gujarati"] = "GUJARATI";
    PreferredLanguage["HatianCreole"] = "HATIAN_CREOLE";
    PreferredLanguage["Hebrew"] = "HEBREW";
    PreferredLanguage["Hindi"] = "HINDI";
    PreferredLanguage["Hungarian"] = "HUNGARIAN";
    PreferredLanguage["Italian"] = "ITALIAN";
    PreferredLanguage["Japanese"] = "JAPANESE";
    PreferredLanguage["Korean"] = "KOREAN";
    PreferredLanguage["Mandarin"] = "MANDARIN";
    PreferredLanguage["Polish"] = "POLISH";
    PreferredLanguage["Portuguese"] = "PORTUGUESE";
    PreferredLanguage["Punjabi"] = "PUNJABI";
    PreferredLanguage["Romanian"] = "ROMANIAN";
    PreferredLanguage["Russian"] = "RUSSIAN";
    PreferredLanguage["Serbian"] = "SERBIAN";
    PreferredLanguage["Sinhalese"] = "SINHALESE";
    PreferredLanguage["Spanish"] = "SPANISH";
    PreferredLanguage["Turkish"] = "TURKISH";
    PreferredLanguage["Ukrainian"] = "UKRAINIAN";
    PreferredLanguage["Urdu"] = "URDU";
    PreferredLanguage["Vietnamese"] = "VIETNAMESE";
})(PreferredLanguage || (PreferredLanguage = {}));
export var PublicFileTypeEnum;
(function (PublicFileTypeEnum) {
    PublicFileTypeEnum["CsvUpload"] = "CSV_UPLOAD";
    PublicFileTypeEnum["DocumentUpload"] = "DOCUMENT_UPLOAD";
    PublicFileTypeEnum["ImageUpload"] = "IMAGE_UPLOAD";
    PublicFileTypeEnum["OtherUpload"] = "OTHER_UPLOAD";
    PublicFileTypeEnum["PdfUpload"] = "PDF_UPLOAD";
    PublicFileTypeEnum["VideoUpload"] = "VIDEO_UPLOAD";
    PublicFileTypeEnum["ZipUpload"] = "ZIP_UPLOAD";
})(PublicFileTypeEnum || (PublicFileTypeEnum = {}));
export var PublicPriorityEmailAction;
(function (PublicPriorityEmailAction) {
    PublicPriorityEmailAction["PriorityGlobalInviteAccept"] = "PRIORITY_GLOBAL_INVITE_ACCEPT";
    PublicPriorityEmailAction["PriorityGlobalInviteDecline"] = "PRIORITY_GLOBAL_INVITE_DECLINE";
    PublicPriorityEmailAction["PriorityOrganizationInviteAccept"] = "PRIORITY_ORGANIZATION_INVITE_ACCEPT";
    PublicPriorityEmailAction["PriorityOrganizationInviteDecline"] = "PRIORITY_ORGANIZATION_INVITE_DECLINE";
})(PublicPriorityEmailAction || (PublicPriorityEmailAction = {}));
export var PublicPriorityEmailType;
(function (PublicPriorityEmailType) {
    PublicPriorityEmailType["PriorityGlobalInvite"] = "PRIORITY_GLOBAL_INVITE";
    PublicPriorityEmailType["PriorityOrganizationInvite"] = "PRIORITY_ORGANIZATION_INVITE";
    PublicPriorityEmailType["PriorityReferralForCaregivers"] = "PRIORITY_REFERRAL_FOR_CAREGIVERS";
})(PublicPriorityEmailType || (PublicPriorityEmailType = {}));
export var PublicPriorityReferralAction;
(function (PublicPriorityReferralAction) {
    PublicPriorityReferralAction["PriorityReferralForCaregiversAccept"] = "PRIORITY_REFERRAL_FOR_CAREGIVERS_ACCEPT";
    PublicPriorityReferralAction["PriorityReferralForCaregiversDecline"] = "PRIORITY_REFERRAL_FOR_CAREGIVERS_DECLINE";
})(PublicPriorityReferralAction || (PublicPriorityReferralAction = {}));
export const UnsubscribeFromLinkDocument = gql `
    mutation UnsubscribeFromLink($key1: String!, $key2: String!) {
        emailPreferences {
            unsubscribeFromLink(key1: $key1, key2: $key2) {
                success
            }
        }
    }
`;
export function useUnsubscribeFromLinkMutation() {
    return Urql.useMutation(UnsubscribeFromLinkDocument);
}
export const UpdateEmailPreferenceDocument = gql `
    mutation UpdateEmailPreference($input: PublicUpdateEmailPreferencesInput!) {
        emailPreferences {
            updateEmailPreference(input: $input) {
                emailPreferenceId
                shouldSend
            }
        }
    }
`;
export function useUpdateEmailPreferenceMutation() {
    return Urql.useMutation(UpdateEmailPreferenceDocument);
}
export const CreatePublicWebsiteLeadDocument = gql `
    mutation CreatePublicWebsiteLead($input: PublicUnifiedPriorityEntryInput!) {
        websiteLeads {
            createWebsiteLead(input: $input) {
                success
            }
        }
    }
`;
export function useCreatePublicWebsiteLeadMutation() {
    return Urql.useMutation(CreatePublicWebsiteLeadDocument);
}
export const CreatePublicUploadFilePresignedUrlDocument = gql `
    mutation CreatePublicUploadFilePresignedUrl(
        $input: PublicUploadFilePresignedUrlInput!
    ) {
        files {
            createPublicUploadFilePresignedUrl(input: $input) {
                presignedUrl
                caregiverId
                patientId
            }
        }
    }
`;
export function useCreatePublicUploadFilePresignedUrlMutation() {
    return Urql.useMutation(CreatePublicUploadFilePresignedUrlDocument);
}
export const CreatePublicFileRecordDocument = gql `
    mutation CreatePublicFileRecord($input: CreatePublicFileInput!) {
        files {
            createPublicFileRecord(input: $input) {
                success
                error
            }
        }
    }
`;
export function useCreatePublicFileRecordMutation() {
    return Urql.useMutation(CreatePublicFileRecordDocument);
}
export const UpdatePublicPriorityEmailRecordDocument = gql `
    mutation UpdatePublicPriorityEmailRecord(
        $input: PublicPriorityEmailRecordUpdateInput!
    ) {
        priorityEmailRecords {
            updatePriorityEmailRecord(input: $input)
        }
    }
`;
export function useUpdatePublicPriorityEmailRecordMutation() {
    return Urql.useMutation(UpdatePublicPriorityEmailRecordDocument);
}
export const CreatePublicUnifiedPriorityEntryDocument = gql `
    mutation CreatePublicUnifiedPriorityEntry(
        $key1: String!
        $key2: String!
        $input: UnifiedPriorityEntryInput!
    ) {
        priorityEntries {
            createPublicUnifiedPriorityEntry(
                key1: $key1
                key2: $key2
                input: $input
            ) {
                success
            }
        }
    }
`;
export function useCreatePublicUnifiedPriorityEntryMutation() {
    return Urql.useMutation(CreatePublicUnifiedPriorityEntryDocument);
}
export const UpdatePublicPriorityReferralDocument = gql `
    mutation UpdatePublicPriorityReferral(
        $input: PublicPriorityReferralUpdateInput!
    ) {
        priorityReferrals {
            updatePriorityReferral(input: $input) {
                success
            }
        }
    }
`;
export function useUpdatePublicPriorityReferralMutation() {
    return Urql.useMutation(UpdatePublicPriorityReferralDocument);
}
export const GetEmailPreferencesDocument = gql `
    query GetEmailPreferences($key1: String!, $key2: String!) {
        emailPreferences {
            emailPreferences(key1: $key1, key2: $key2) {
                emailPreferenceId
                emailPreferenceType
                shouldSend
            }
        }
    }
`;
export function useGetEmailPreferencesQuery(options) {
    return Urql.useQuery({ query: GetEmailPreferencesDocument, ...options });
}
export const PublicPriorityEmailRecordDocument = gql `
    query PublicPriorityEmailRecord($key1: String!, $key2: String!) {
        priorityEmailRecords {
            priorityEmailRecord(key1: $key1, key2: $key2) {
                organizationName
                patientName
                therapyCategoryName
                priorityEmailType
                intakeFormUrl
            }
        }
    }
`;
export function usePublicPriorityEmailRecordQuery(options) {
    return Urql.useQuery({ query: PublicPriorityEmailRecordDocument, ...options });
}
export const GetPublicPriorityEntryDetailsDocument = gql `
    query GetPublicPriorityEntryDetails($key1: String!, $key2: String!) {
        priorityEntries {
            publicPriorityEntryDetails(key1: $key1, key2: $key2) {
                organizationId
                name
                imageUrl
                isExpired
            }
        }
    }
`;
export function useGetPublicPriorityEntryDetailsQuery(options) {
    return Urql.useQuery({ query: GetPublicPriorityEntryDetailsDocument, ...options });
}
export const GetPublicInviteLandingEntitiesDocument = gql `
    query GetPublicInviteLandingEntities($organizationId: String!) {
        conditions {
            conditionsList {
                value
                label
            }
        }
        therapyCategories {
            therapyCategoriesList(organizationId: $organizationId) {
                value
                label
            }
        }
    }
`;
export function useGetPublicInviteLandingEntitiesQuery(options) {
    return Urql.useQuery({ query: GetPublicInviteLandingEntitiesDocument, ...options });
}
export const GetPublicInsuranceEntitiesDocument = gql `
    query GetPublicInsuranceEntities($search: String) {
        insurances {
            insurancesList(search: $search) {
                value
                label
            }
        }
    }
`;
export function useGetPublicInsuranceEntitiesQuery(options) {
    return Urql.useQuery({ query: GetPublicInsuranceEntitiesDocument, ...options });
}
export const GetPublicTherapySubCategoryGroupsDocument = gql `
    query GetPublicTherapySubCategoryGroups($therapyCategoryIds: [String!]) {
        therapySubCategories {
            therapySubCategoryGroups(therapyCategoryIds: $therapyCategoryIds) {
                group
                items {
                    value
                    label
                }
            }
        }
    }
`;
export function useGetPublicTherapySubCategoryGroupsQuery(options) {
    return Urql.useQuery({ query: GetPublicTherapySubCategoryGroupsDocument, ...options });
}
export const GetPublicOrganizationDetailsDocument = gql `
    query GetPublicOrganizationDetails($organizationId: String!) {
        organizations {
            publicOrganizationDetails(organizationId: $organizationId) {
                organizationId
                name
                imageUrl
            }
        }
    }
`;
export function useGetPublicOrganizationDetailsQuery(options) {
    return Urql.useQuery({ query: GetPublicOrganizationDetailsDocument, ...options });
}
